import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginCommunicationService {

  private changeLoginStatusSource = new Subject<String>();
  loginStatusChanged = this.changeLoginStatusSource.asObservable();

  constructor() { }

  changeLoginStatus(newLoginStatus: String) {
    this.changeLoginStatusSource.next(newLoginStatus);
  }
}
